module.exports = __webpack_public_path__ + "img/linkedin.3a0f1c50.svg";